// Helper function to tell the browser how to parse custom CSS properties
function registerVar(name: string, syntax: string, initialValue?: string) {
  window.CSS.registerProperty({
    name,
    syntax,
    inherits: false,
    initialValue,
  })
}

registerVar(
  '--sticky-stuck-radial-gradient-center-color',
  '<color>',
  'rgb(0 0 0 / 0%)'
)

registerVar(
  '--sticky-stuck-radial-gradient-y',
  '<percentage>',
  '0%'
)
